import Phaser from "phaser";

class BootScene extends Phaser.Scene {
  constructor() {
    super({
      key: "BootScene",
    });
  }

  preload() {
    // load all files necessary for the loading screen
    // this.load.image("loading", require("../../../assets/33-logo.png"));
    this.load.atlas('loading', require('../../assets/atlas/loading-v.2.png'), require('../../assets/atlas/loading-v.2_atlas.json'));

  }

  create() {
    this.scene.start("PreloadScene");
  }
}
export default BootScene;
